const $ = require('jquery');

module.exports = function (breakpointsService) {
    return {
        link(scope, element, attrs) {
            const val = attrs.bwsScrollToElement,
                  targetEl = "[scroll-to-element-target='" + val + "']",
                  $BODY = breakpointsService.getScrollElement();

            element.click(function () {
                const $target = $(targetEl);

                $BODY.animate({
                    scrollTop: $BODY.scrollTop() + $target.offset().top - breakpointsService.getScrollOffset()
                }, 450);

            });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/scroll-to-element/scroll-to-element-directive.js
 **/